import React, { PureComponent } from 'react';
import StepCard from '../../components/StepCard';
import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';
import { actions as signupActions } from '../../reducers/signups';
import { Flex } from 'Common/components/Atoms/Flex';
import { Link } from 'Common/components/Atoms/Link';
import { Text } from 'Common/components/Atoms/Text';

export interface Props {
  isUpdating: boolean;
  acceptReviewerTerms: () => void;
}

interface State {
  terms: boolean;
  privacy: boolean;
  error: boolean;
}

export class ReviewerProfileTerms extends PureComponent<Props, State> {
  state: State = {
    terms: false,
    privacy: false,
    error: false,
  };

  handleSubmit = () => {
    const { acceptReviewerTerms } = this.props;
    const { terms, privacy } = this.state;
    if (!terms || !privacy) {
      this.setState({ error: true });
    } else {
      acceptReviewerTerms();
    }
  };

  render(): JSX.Element {
    const { isUpdating } = this.props;
    const { terms, privacy, error } = this.state;
    return (
      <StepCard
        showPreviousButton={false}
        handleSubmit={this.handleSubmit}
        isUpdating={isUpdating}
      >
        <Text variant="body1" mb={3}>
          Before completing signup, please review and agree to the following:
        </Text>
        <Flex alignItems="center" justifyContent="flex-start" mb={1}>
          <input
            data-testid="qa-terms-checkbox"
            style={{ height: '16px', width: '16px' }}
            type="checkbox"
            checked={terms}
            onChange={() => this.setState({ terms: !terms, error: false })}
          />
          <Link
            href="https://www.pullrequest.com/terms"
            target="_blank"
            fontSize="14px"
            ml={2}
          >
            Terms of Service
          </Link>
        </Flex>
        <Flex alignItems="center">
          <input
            data-testid="qa-privacy-checkbox"
            style={{ height: '16px', width: '16px' }}
            type="checkbox"
            checked={privacy}
            onChange={() => this.setState({ privacy: !privacy, error: false })}
          />
          <Link
            href="https://www.pullrequest.com/privacy"
            target="_blank"
            fontSize="14px"
            ml={2}
          >
            Privacy Policy
          </Link>
        </Flex>
        <Text variant="body1" color="textSecondary" mt={3}>
          By checking the above you verify that you have read and agreed to the
          PullRequest terms of service and privacy policy.
        </Text>
        {error && (
          <Text
            variant="caption"
            color="error"
            mt={3}
            data-testid="qa-error-message"
          >
            You must accept the Terms of Service and the Privacy Policy to
            continue.
          </Text>
        )}
      </StepCard>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    isUpdating: state.signups.isUpdating,
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return bindActionCreators(signupActions, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewerProfileTerms);
